import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles, Gift, Wine, Coins, Coffee, Sparkle } from 'lucide-react';
import { categories } from '../shopData';
import Ornament from './Ornament';

const iconMap = {
  Sparkles: Sparkles,
  Utensils: Wine,
  Gift: Gift,
  Wine: Wine,
  Coins: Coins,
  Coffee: Coffee
};

const Categories = () => {
  const navigate = useNavigate();

  return (
    <section id="categories" className="section-padding bg-dark">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <div className="lux-eyebrow">Our Collection</div>
          <h2 className="lux-title">
            Exquisite Product Range
          </h2>
          <Ornament />
          <p className="lux-subtitle">
            From sacred idols and utensils to designer gift items and premium jewellery &mdash;
            discover our curated collection of fine silver crafted with heritage.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {categories.slice(0, 5).map((category) => {
            const IconComponent = iconMap[category.icon || 'Sparkles'];
            return (
              <div
                key={category.id}
                data-testid={`category-card-${category.slug}`}
                className="category-card cursor-pointer"
                onClick={() => navigate(`/shop/${category.slug}`)}
              >
                <div className="category-image-wrapper">
                  <img
                    src={category.image}
                    alt={category.name}
                    className="category-image"
                  />
                  <div className="category-overlay">
                    <div className="category-icon">
                      <IconComponent size={32} />
                    </div>
                  </div>
                </div>
                <div className="category-content">
                  <h3 className="category-title">{category.name}</h3>
                  <p className="category-description">{category.description}</p>
                </div>
              </div>
            );
          })}

          {/* Customised Orders — 6th card */}
          <div
            data-testid="category-card-customised-orders"
            className="category-card cursor-pointer customised-card"
            onClick={() => navigate('/customised-orders')}
          >
            <div className="customised-card-inner">
              <div className="customised-card-ornament" aria-hidden="true">
                <div className="ornament-line"></div>
                <Sparkle size={22} className="ornament-sparkle" />
                <div className="ornament-line"></div>
              </div>
              <div className="customised-card-badge">Custom Made</div>
              <h3 className="customised-card-title">Customised Orders</h3>
              <p className="customised-card-subtitle">
                Have something special in mind? We'll craft it in pure silver, just the way you want.
              </p>
              <div className="customised-card-cta">
                <span>Get Yours Made</span>
                <span className="customised-card-arrow">&rarr;</span>
              </div>
            </div>
          </div>
        </div>

        {/* Single aesthetic catalogue CTA */}
        <div className="catalogue-cta-wrap">
          <a
            href="https://wa.me/c/919893254712"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="catalogue-whatsapp-cta"
            className="catalogue-cta"
          >
            <span className="catalogue-cta-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
              </svg>
            </span>
            <span className="catalogue-cta-text">
              Browse Full Catalogue on WhatsApp
            </span>
            <span className="catalogue-cta-arrow" aria-hidden="true">&rarr;</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Categories;
